import React from "react";
import {useParams} from 'react-router-dom';
import OrderItemsList from "../../components/event/OrderItemsList";

const OrderItemsPage = () => {
    const {orderId} = useParams();

    return <OrderItemsList orderId={orderId}/>
}

export default OrderItemsPage;
